<script setup lang="ts">
interface Props {
  pageUrl: String | string;
  width?: Number | number | undefined;
  height?: Number | number | undefined;
  [x: string]: any;
};

const props = withDefaults(defineProps<Props>(), {
  width: undefined, // 340,
  height: undefined // 500
});

const loadFacebookSdk = () => {
  return new Promise((resolve, reject) => {
    if (window.FB) {
      return resolve(window.FB);
    }
    if (document.getElementById('facebook-jssdk')) {
      const checkInterval = setInterval(() => {
        if (window.FB) {
          clearInterval(checkInterval);
          resolve(window.FB);
        }
      }, 100);
      return;
    }
    // Define fbAsyncInit BEFORE appending the script
    window.fbAsyncInit = () => {
      window.FB.init({
        xfbml: true,
        version: 'v21.0'
      });
      resolve(window.FB);
    };
    const script = document.createElement('script');
    script.id = 'facebook-jssdk';
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.async = true;
    script.defer = true;
    script.onerror = (error) => {
      console.warn('Facebook SDK failed to load, ignoring gracefully.', error);
      reject(error);
    };
    document.body.appendChild(script);
  });
};

onMounted(async () => {
  try {
    const FB = await loadFacebookSdk();
    await nextTick();
    setTimeout(() => {
      if (FB ? typeof FB.XFBML !== 'undefined' : false)
        FB?.XFBML?.parse();
    }, 200);
  } catch (err) {
    // Fails safely
  }
});

const widthAdapt = computed(() => {
  if (props.width)
    return props.width;
  switch(useNuxtApp()?.$styleSize?.value) {
    case '2xl':
      return 680;
    case 'xl':
    case 'lg':
      return 510;
    case 'md':
    case 'sm':
    default:
      return 340;
  }
});

const heightAdapt = computed(() => {
  if (props.height)
    return props.height;
  switch(useNuxtApp()?.$styleSize?.value) {
    case '2xl':
      return 1000;
    case 'xl':
    case 'lg':
      return 750;
    case 'md':
    case 'sm':
    default:
      return 500;
  }
});

const emit = defineEmits(['click', 'focus']);
</script>

<template>
  <div
    class="block relative w-full h-full overflow-auto text-center"
    @click="(e: Event) => emit('click', e)"
    @focus="(e: Event) => emit('focus', e)">
    <div
      class="fb-page"
      :data-href="pageUrl"
      data-tabs="timeline"
      :data-width="widthAdapt"
      :data-height="heightAdapt"
      data-small-header="true"
      :data-adapt-container-width="(widthAdapt ? false : true)"
      data-hide-cover="true"
      data-show-facepile="true">
      <blockquote
        :cite="pageUrl"
        class="fb-xfbml-parse-ignore">
        <a :href="pageUrl">Loading Facebook Page...</a>
      </blockquote>
    </div>
  </div>
</template>
